import { IMenu } from "@/types/menu-d-t";

export const menu_data: IMenu[] = [
  {
    id: 1,
    title: "Academics",
    titleAr: "أكاديمي",
    link: "#",
    academics: true,
    pages_dropdown: [
      {
        id: 1,
        title: "HTU Schools",
        titleAr: "كليات الجامعة",
        link: "/htu-schools",
        dropdown_menus: [
          {
            id: 1,
            title: "School of Engineering Technology",
            titleAr: "كليّة الهندسة التكنولوجيّة",
            link: "/schools/set",
          },
          {
            id: 2,
            title: "School of Computing and Informatics",
            titleAr: "كليّة الحاسوب والمعلوماتيّة",
            link: "/schools/sci",
          },
          {
            id: 3,
            title: "School of Built Environment Engineering",
            titleAr: "كليّة هندسة البيئة المبنيّة",
            link: "/schools/sbee",
          },
          {
            id: 4,
            title: "School of Social and Basic Sciences",
            titleAr: "كليّة العلوم الاجتماعيّة والأساسيّة",
            link: "/schools/ssbs",
          },
        ],
      },
      {
        id: 2,
        title: "Deanships",
        titleAr: "العمادات",
        dropdown_menus: [
          {
            id: 6,
            title: "Deanship of Scientific Research",
            titleAr: "عمادة البحث العلمي والابتكار",
            link: "/deanships/deanship-of-scientific-research",
          },
          {
            id: 7,
            title: "Deanship of Student Affairs",
            titleAr: "عمادة شؤون الطلبة",
            link: "/deanships/deanship-of-student-affairs",
          },
        ],
      },
      {
        id: 3,
        title: "Faculty Members",
        titleAr: "أعضاء الهيئة الأكاديميّة",
        link: "/faculty-members",
        noBorder: true,
        dropdown_menus: [],
      },
    ],
    sm_mega_menus: [
      {
        id: 1,
        title: "School of Engineering Technology",
        titleAr: "كليّة الهندسة التكنولوجيّة",
        link: "/schools/set",
      },
      {
        id: 2,
        title: "School of Computing and Informatics",
        titleAr: "كليّة الحاسوب والمعلوماتيّة",
        link: "/schools/sci",
      },
      {
        id: 3,
        title: "School of Built Environment Engineering",
        titleAr: "كليّة هندسة البيئة المبنيّة",
        link: "/schools/sbee",
      },
      {
        id: 4,
        title: "School of Social and Basic Sciences",
        titleAr: "كليّة العلوم الاجتماعيّة والأساسيّة",
        link: "/schools/ssbs",
      },
      {
        id: 6,
        title: "Deanship of Scientific Research",
        titleAr: "عمادة البحث العلمي والابتكار",
        link: "/deanships/deanship-of-scientific-research",
      },
      {
        id: 7,
        title: "Deanship of Student Affairs",
        titleAr: "عمادة شؤون الطلبة",
        link: "/deanships/deanship-of-student-affairs",
      },
    ],
  },
  {
    id: 2,
    title: "Admission",
    titleAr: "القبول",
    link: "#",
    dropdown_menus: [
      {
        id: 1,
        title: "Programs",
        titleAr: "البرامج الدراسيّة",
        link: "/admission/programs",
      },
      {
        id: 2,
        title: "How to Apply",
        titleAr: "آلية التقديم",
        link: "/admission/how-to-apply",
      },

      {
        id: 3,
        title: "Requirements",
        titleAr: "متطلبات القبول",
        link: "/admission/requirements",
      },
      {
        id: 4,
        title: "Tuition and Fees",
        titleAr: "الرسوم الدراسية",
        link: "/admission/tuition-and-fees",
      },
      {
        id: 5,
        title: "Scholarships",
        titleAr: "المنح الدراسية",
        link: "/admission/scholarships",
      },
      {
        id: 6,
        title: "FAQs",
        titleAr: "الأسئلة الأكثر تكرارًا",
        link: "/admission/faqs",
      },
    ],
  },
  {
    id: 3,
    title: "Centers",
    titleAr: "المراكز",
    link: "#",
    sm_mega_menus: [
      {
        id: 1,
        title: "The Core@HTU",
        titleAr: "مركز التميّز للريادة والابتكار",
        link: "/centers/center-for-innovation-and-entrepreneurial-excellence",
      },
      {
        id: 2,
        title: "Center of Professional Development & Community Outreach",
        titleAr: "مركز التطوير الوظيفي والتواصل المجتمعي",
        link: "/centers/center-of-professional-development-&-community-outreach",
      },
      {
        id: 3,
        title: "Digital Learning Center",
        titleAr: "مركز التعلّم الرقمي",
        link: "/centers/digital-learning-center",
      },
      {
        id: 4,
        title: "India Jordan Center of Excellence in IT",
        titleAr: "المركز الهندي الأردني للتميّز في تكنولوجيا المعلومات",
        link: "/departments/india-jordan-center-of-excellence-in-it",
      },
      {
        id: 5,
        title: "German Energy Academy",
        titleAr: "أكاديميّة الطاقة الألمانيّة",
        link: "/departments/german-energy-academy",
      },
      {
        id: 6,
        title: "Office of Industrial Partnership",
        titleAr: "مكتب الشراكة مع الصناعة",
        link: "/offices/office-of-industrial-partnership",
      },
      {
        id: 7,
        title: "Office of International Relations",
        titleAr: "مكتب العلاقات الدوليّة",
        link: "/offices/office-of-international-relations",
      },
    ],
  },
  {
    id: 4,
    title: "Units & Departments",
    titleAr: "الوحدات والدوائر",
    link: "#",
    noDropdown: false,
    pages_dropdown: [
      {
        id: 1,
        title: "Units",
        titleAr: "الوحدات",
        dropdown_menus: [
          {
            id: 1,
            title: "Financial Affairs Unit",
            titleAr: "وحدة الشؤون المالية",
            link: "/units/financial-affairs-unit",
          },
          {
            id: 2,
            title: "Marketing and Communication Unit",
            titleAr: "وحدة التسويق والاتصال",
            link: "/units/marketing-and-communications-unit",
          },
          {
            id: 3,
            title: "Human Resources Unit",
            titleAr: "وحدة الموارد البشرية",
            link: "/units/human-resources-unit",
          },
          {
            id: 4,
            title: "Computer and Information Technology Unit",
            titleAr: "وحدة الحاسوب وتكنولوجيا المعلومات",
            link: "/units/computer-and-information-technology-unit",
          },
          {
            id: 5,
            title: "Facilities Management and Security Services Unit",
            titleAr: "وحدة إدارة المرافق والأمن الجامعي",
            link: "/units/facilities-management-and-security-services-unit",
          },
        ],
      },
      {
        id: 2,
        title: "Departments",
        titleAr: "الدوائر",
        dropdown_menus: [
          {
            id: 1,
            title: "Presidency Department",
            titleAr: "دائرة الرئاسة",
            link: "/units/presidency-department",
          },
          {
            id: 2,
            title: "Admission and Registration Department",
            titleAr: "دائرة القبول والتسجيل",
            link: "/departments/admission-and-registration-department",
          },
          {
            id: 3,
            title: "Library",
            titleAr: "المكتبة",
            link: "/departments/library",
          },
          {
            id: 4,
            title: "Tenders and Supplies Department",
            titleAr: "دائرة العطاءات والمشتريات",
            link: "/departments/tenders-and-supplies-department#tenders-section",
          },

          {
            id: 5,
            title: "Councils Affairs Department",
            titleAr: "دائرة أمانة سر المجالس",
            link: "/departments/councils-affairs-department",
          },
          {
            id: 6,
            title: "Accreditation and Quality Assurance Department (PEARSON)",
            titleAr: "دائرة ضمان الجودة الأكاديميّة - بيرسون",
            link: "/departments/accreditation-and-quality-assurance-department",
          },
        ],
      },
      {
        id: 3,
        title: "Offices",
        titleAr: "المكاتب",
        dropdown_menus: [
          {
            id: 1,
            title: "Office of Advancement",
            titleAr: "مكتب المنح واستقطاب التمويل",
            link: "/offices/office-of-advancement",
          },
          {
            id: 2,
            title: "Directorate Jordan Armed Forces (JAF)",
            titleAr: "مكتب ركن البعثات العسكرية",
            link: "/offices/education-and-military-culture-directorate-jordan-armed-forces-(jaf)",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: "About",
    titleAr: "حول",
    link: "#",
    dropdown_menus: [
      { id: 1, title: "Overview", titleAr: "نظرة عامة", link: "/about-htu" },
      {
        id: 2,
        title: "Governance",
        titleAr: "الحوكمة",
        link: "/governance",
      },
      {
        id: 3,
        title: "President's Message",
        titleAr: "كلمة الرئيس",
        link: "/president-message",
      },
      // {
      //   id: 4,
      //   title: "Faculty Members",
      //   link: "/faculty-members",
      // },
      {
        id: 4,
        title: "News",
        titleAr: "الأخبار",
        link: "/news",
      },
      {
        id: 5,
        title: "Newsletter",
        titleAr: "النشرة الشهريّة",
        link: "/newsletter",
      },
      // { id: 7, title: "Gallery", link: "/" },
      {
        id: 7,
        title: "Vacancies",
        titleAr: "شواغر",
        link: "/vacancies",
      },
      {
        id: 8,
        title: "Contact",
        titleAr: "للتواصل",
        link: "/contact",
      },
    ],
  },
];

export const menu_data_2: IMenu[] = [
  {
    id: 1,
    title: " Employee Portal",
    titleAr: "بوابة الموظفين",
    link: "https://eis.htu.edu.jo/",
    noDropdown: true,
  },
  {
    id: 2,
    title: "Students Portal",
    titleAr: "بوابة الطلاب",
    link: "https://sis.htu.edu.jo/",
    noDropdown: true,
  },
  {
    id: 3,
    title: "E-learning",
    titleAr: "التعليم الالكتروني",
    link: "https://elearning.htu.edu.jo/login/index.php",
    noDropdown: true,
  },
  {
    id: 4,
    title: "Pearson Support Hub",
    titleAr: "دعم بيرسون",
    link: "https://www.htu.edu.jo/Pearson/",
    noDropdown: true,
  },
];

export const secondary_menu_data: IMenu[] = [
  {
    id: 0,
    title: "Home",
    titleAr: "الرئيسية",
    link: "/htu-giving",
    noDropdown: true,
  },
  {
    id: 1,
    title: "How to Give",
    titleAr: "كيفية التبرع",
    link: "/how-to-give",
    noDropdown: true,
  },
  {
    id: 2,
    title: "Giving Opportunities",
    titleAr: "فرص وإمكانيات العطاء",
    link: "/giving-opportunities",
    noDropdown: true,
  },
  {
    id: 3,
    title: "Impact",
    titleAr: "الأثر",
    link: "/impact",
    noDropdown: true,
  },
  {
    id: 4,
    title: "Alumni",
    titleAr: "خريجون",
    link: "/alumni",
    noDropdown: true,
  },
  {
    id: 5,
    title: "Roll of Honor",
    titleAr: "قائمة الشرف",
    link: "/roll-of-honor",
    noDropdown: true,
  },
];
